export default [{
  path: '/gdindex',
  name: 'gdindex',
  meta: {
    title: '中行喊你充话费',
    notShare: false
  },
  component: () => import('@/pages/GDcallfee/blank')
}, {
  path: '/gdcallfee',
  name: 'gdcallfee',
  meta: {
    title: '中行喊你充话费',
    notShare: false
  },
  component: () => import('@/pages/GDcallfee/Index')
}, {
  path: '/gdregister',
  name: 'gdregister',
  meta: {
    title: '中行喊你充话费',
    notShare: false
  },
  component: () => import('@/pages/GDcallfee/Register')
}, {
  path: '/gdrechargeresult',
  name: 'gdrechargeresult',
  meta: {
    title: '中行喊你充话费',
    notShare: false
  },
  component: () => import('@/pages/GDcallfee/rechargeResult')
}, {
  path: '/gdqrcode',
  name: 'gdqrcode',
  meta: {
    title: '关注中国银行广东省分行',
    notShare: false
  },
  component: () => import('@/pages/GDcallfee/Qrcode')
}]



// WEBPACK FOOTER //
// ./src/router/GDindex.js